// internationalization
import type { TFunction } from 'i18next';

// relative
import { ALARM_GROUP_SEVERITY_LEVELS } from './createAlarmGroupForm.schema';

// libraries
import { z } from 'zod';

export function createEditAlarmGroupFormSchema(t: TFunction) {
  return z.object({
    groupName: z
      .string()
      .trim()
      .min(1, t('input.required', { ns: 'validation' })),
    users: z
      .array(
        z.object({
          user: z.string(),
          feedSeverity: z.enum(ALARM_GROUP_SEVERITY_LEVELS),
          emailSeverity: z.enum(ALARM_GROUP_SEVERITY_LEVELS),
        }),
      )
      .refine(
        (users) => users.some((user) => user.user.trim().length > 0),
        t('createAlarmGroup.atLeastOneUserRequired', { ns: 'forms' }),
      ),
    alarmTypes: z.array(z.number()),
  });
}

export type EditAlarmGroupFormValues = z.infer<
  ReturnType<typeof createEditAlarmGroupFormSchema>
>;
